import React from "react";

const IconTheatreModeRevert = (props?: { iconFill?: string, className?: string, defs?: React.ReactNode }) => {
    return (
        <svg
            className={ props?.className }
            xmlns="http://www.w3.org/2000/svg"
            fillRule="evenodd"
            strokeLinejoin="round"
            strokeMiterlimit="2"
            clipRule="evenodd"
            viewBox="0 0 24 24"
        >
            { props?.defs ? props.defs : null }
            <path fill={ props?.iconFill } fillRule="nonzero" d="M22 5c0-.478-.379-1-1-1H3c-.62 0-1 .519-1 1v14c0 .621.52 1 1 1h18c.478 0 1-.379 1-1zM10.5 18.5h-7v-4h7zm1.5 0V14c0-.478-.379-1-1-1H3.5V5.5h17v13zm2.5-8.057V9.2a.75.75 0 0 0-1.5 0v3.05c0 .414.336.75.75.75h3.033a.75.75 0 0 0 0-1.5h-1.218l3.198-3.198a.75.75 0 0 0 0-1.061.75.75 0 0 0-1.061 0z"> </path>
        </svg>
    )
};

export default IconTheatreModeRevert;
